import React from "react";
import './NonAuthorized.css';
import codeimg from '../../assets/images/code.svg';
const NonAuthorized = () => {
  return (
    <div className="nonauthorized-container  ">
      <div className="row">
        <div className="col-sm-4">
          <img src={codeimg} alt="codeimage"/>
        </div>
        <div className="col-sm-8">
          <div className="heading">Oops!</div>
          <div className="error-body">
            <p className="message">You Don't Have Access For this website Contact Admin.</p>
          </div>
        </div>
      </div>
      
      
    </div>
  )
};

export default NonAuthorized;